import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Gressingham9';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/service-worker.js')
      .then(function(reg) { console.log('SW registered'); })
      .catch(function(err) { console.log('SW failed: ', err); });
  });
}
